var exports = {
  "qr": "xe564cbfb--e70874--footer",
  "CB": "xe564cbfb--e70874--footer-content",
  "A3": "xe564cbfb--e70874--footer-actions",
  "th": "xe564cbfb--e70874--print-button",
};

module.exports = exports;
